import { createApiClient } from '@/shared/api/createApiClient';
import { addSpoofInterceptor } from '@/shared/spoof/addSpoofInterceptor';

export const extranetApiClient = createApiClient(
  'extranet_auth_token',
  'extranet_active_tenant_id',
);

addSpoofInterceptor(extranetApiClient, 'extranet', 'extranet_session_id');
